module.exports = __webpack_public_path__ + "img/antes_despues_247.fb08661e.png";